import React from 'react';
import { HeroSection } from './HeroSection';
import { TruthSection } from './TruthSection';
import { ProductIntro } from './ProductIntro';
import { RealExample } from './RealExample';
import { WhyWomenDont } from './WhyWomenDont';
import { FinalCTA } from './FinalCTA';
import { FAQSection } from './FAQSection';
import { Footer } from './Footer';
import { SocialProofNotification } from './SocialProofNotification';
import { FloatingCTA } from './FloatingCTA';
export function SalesPage() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-cream-50" data-id="element-212">
      <HeroSection data-id="element-213" />
      <TruthSection data-id="element-214" />

      <ProductIntro data-id="element-215" />
      <RealExample data-id="element-216" />
      <WhyWomenDont data-id="element-217" />

      <FinalCTA data-id="element-218" />
      <FAQSection data-id="element-219" />
      <Footer data-id="element-220" />
      <SocialProofNotification data-id="element-221" />
      <FloatingCTA data-id="element-222" />
    </main>;
}